import React from "react";
import { Link } from "react-router-dom";
import * as S from "./styles";
import sellitNegativa from "../../../assets/sellitNegativa.png";

const Header: React.FC = () => {
  return (
    <S.Container>
      <S.Row>
        <img src={sellitNegativa} alt="Sellit Logo" />
      </S.Row>
      <S.Row>
        <p>Termos de uso</p>
      </S.Row>
    </S.Container>
  );
};

export default Header;
